import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Markdown 渲染组件 — 直接输出后端渲染的 HTML
 */
export function MarkdownRenderer({ contentHtml }) {
    return (_jsx("div", { className: "markdown-body", style: markdownBodyStyle, dangerouslySetInnerHTML: { __html: contentHtml ?? '' } }));
}
const markdownBodyStyle = {
    fontSize: '16px',
    lineHeight: '1.8',
    color: '#333',
};
//# sourceMappingURL=markdown-renderer.js.map